<script>
export default {
    name: 'GroupsCreateForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {}
    },
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <form-group name="name" :label="$t('name')">
            <b-form-input
                class="border-primary"
                v-model="form.name"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="description" :label="$t('description')">
            <div>
                <b-form-textarea
                class="border-primary"
                    id="textarea"
                    v-model="form.description"
                    :placeholder="$t('description')"
                ></b-form-textarea>
            </div>
        </form-group>         
        </form-wrapper>
    </b-form>
</template>